import ajax from '../utils/request'

const technologyApi = {
    queryList(params) {
        return ajax({
            url: '/technology/list',
            type: 'post',
            params: params
        })
    },
    queryStatList(params) {
        return ajax({
            url: '/technology/stat',
            type: 'post',
            params: params
        })
    },
    // 删除
    deleteItem(params) {
        return ajax({
            url: '/technology/del',
            type: 'post',
            params: params
        })
    },
    // 编辑
    editItem(params) {
        return ajax({
            url: '/technology/update',
            type: 'post',
            params: params
        })
    },
    // 添加
    saveItem(params) {
        return ajax({
            url: '/technology/add',
            type: 'post',
            params: params
        })
    },
}
export default technologyApi
